import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function DebugNavigation() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userStatus, setUserStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log('Initializing debug app...');
        
        // Устанавливаем тестового пользователя
        const testInitData = "test";
        setUser({
          initData: testInitData
        });

        // Получаем статус пользователя
        try {
          const response = await axios.get(`/user_status?initData=${encodeURIComponent(testInitData)}`);
          console.log('User status response:', response.data);
          setUserStatus(response.data);
        } catch (error) {
          console.error('Error getting user status:', error);
          setError('Ошибка получения статуса пользователя');
        }
      } catch (error) {
        console.error('App initialization error:', error);
        setError('Ошибка инициализации приложения');
      } finally {
        setLoading(false);
      }
    };

    initializeApp();
  }, []);

  const goToAgeVerification = () => {
    navigate('/age-verification');
  };

  const goToCharacters = () => {
    navigate('/characters');
  };

  const goToChat = () => {
    navigate('/chat/mika_satoshi');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Отладка навигации</h1>
        
        {error && (
          <div className="mb-8 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Информация о пользователе:</h2>
          <div className="bg-gray-100 p-4 rounded">
            <pre className="text-sm overflow-auto">
              {JSON.stringify({ user, userStatus }, null, 2)}
            </pre>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Навигация:</h2>
          <div className="space-y-4">
            <button
              onClick={goToAgeVerification}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-lg"
            >
              Перейти к проверке возраста
            </button>
            
            <button
              onClick={goToCharacters}
              className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg"
            >
              Перейти к выбору персонажей
            </button>
            
            <button
              onClick={goToChat}
              className="w-full bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-6 rounded-lg"
            >
              Перейти к чату с Mika Satoshi
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Статус:</h2>
          <div className="space-y-2">
            <p><strong>Возраст подтвержден:</strong> {userStatus?.age_verified ? '✅ Да' : '❌ Нет'}</p>
            <p><strong>Сообщений сегодня:</strong> {userStatus?.daily_messages || 0} / {userStatus?.daily_limit || 0}</p>
            <p><strong>Подписка:</strong> {userStatus?.subscription?.name || 'Неизвестно'}</p>
            <p><strong>Тип подписки:</strong> {userStatus?.subscription?.tier || 'Неизвестно'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DebugNavigation;
